/** Live accounts per connection at one facility, keyed by `ledgersync_connections.id`. */
export type FacilityAccountCounts = Readonly<Record<string, number>>

/**
 * Count accounts per connection.
 *
 * @param connectionIds - The connection id of each account (one entry per account)
 * @returns How many accounts each connection has
 */
export function countAccountsByConnection(connectionIds: readonly string[]): FacilityAccountCounts {
  const counts: Record<string, number> = {}
  for (const id of connectionIds) counts[id] = (counts[id] ?? 0) + 1
  return counts
}
